// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA2z5v-VXxgXT8erSuMBvqr3E58TNlUBmE",
  authDomain: "house-ivana.firebaseapp.com",
  projectId: "house-ivana",
  storageBucket: "house-ivana.appspot.com",
  messagingSenderId: "980578198061",
  appId: "1:980578198061:web:9407e65c88b61859c38ea4",
  measurementId: "G-TEENL1639P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };

